<black-ui-modal>
  <button
    *blackModalTrigger="let toggle = toggle"
    (click)="toggle()"
    class="daisy-btn"
  >
    + Add New Recording
  </button>
  <div
    *blackModalContent="let close = close"
    class="reveal-modal"
    (click)="close()"
  >
    <div
      class="reveal-modal-body bg-base-100 text-base-content border border-base-300 rounded-2xl shadow-2xl max-w-xl w-full"
      id="addRecordingModal"
      (click)="$event.stopPropagation()"
    >
      <div class="max-w-full mx-auto px-4 py-4">
        <h5 class="font-bold text-lg mb-2">Add New Recording</h5>
        <div class="daisy-divider"></div>

        <!-- Mode switcher tabs -->
        <div class="daisy-tabs daisy-tabs-boxed mb-4">
          <a
            class="daisy-tab"
            [class.daisy-tab-active]="activeTab === 'file'"
            (click)="switchTab('file')"
          >Add a File</a>
          <a
            class="daisy-tab"
            [class.daisy-tab-active]="activeTab === 'external-url'"
            (click)="switchTab('external-url')"
          >Add a URL</a>
        </div>

        <!-- Add a File tab -->
        @if (activeTab === 'file') {

          <!-- Sub-mode picker -->
          @if (fileSubMode === null) {
            <div class="flex flex-col gap-3">
              <button
                type="button"
                class="daisy-btn daisy-btn-outline daisy-btn-block justify-start gap-3"
                (click)="selectFileSubMode('device')"
              >
                <i class="fas fa-upload"></i> Device Upload
              </button>
              <button
                type="button"
                class="daisy-btn daisy-btn-outline daisy-btn-block justify-start gap-3"
                (click)="selectFileSubMode('url-download')"
              >
                <i class="fas fa-link"></i> Upload from URL
                <span class="daisy-badge daisy-badge-sm daisy-badge-info ml-auto">downloads &amp; stores file</span>
              </button>
              <button
                type="button"
                class="daisy-btn daisy-btn-outline daisy-btn-block justify-start gap-3"
                (click)="selectFileSubMode('google-drive')"
              >
                <i class="fab fa-google-drive text-blue-500"></i>
                Google Drive
              </button>
              @if (drivePickerError) {
                <div class="daisy-alert daisy-alert-error text-sm mt-1">{{ drivePickerError }}</div>
              }
            </div>
          }

          <!-- Device upload sub-mode -->
          @if (fileSubMode === 'device') {
            <form [formGroup]="recordUploadForm" id="recordUploadForm">
              <div class="flex flex-col gap-3">
                <button
                  type="button"
                  class="daisy-btn daisy-btn-ghost daisy-btn-sm self-start"
                  (click)="fileSubMode = null"
                >
                  <i class="fas fa-arrow-left mr-1"></i> Back
                </button>

                <div>
                  <fieldset class="daisy-fieldset">
                    <legend class="daisy-fieldset-legend">Session Title</legend>
                    <input
                      formControlName="sessionName"
                      type="text"
                      required
                      class="daisy-input daisy-input-bordered w-full"
                      placeholder="Enter a title for this recording"
                    />
                  </fieldset>
                  @if (
                    recordUploadForm.controls.sessionName.invalid &&
                    (recordUploadForm.controls.sessionName.dirty ||
                      recordUploadForm.controls.sessionName.touched)
                  ) {
                    @if (recordUploadForm.controls.sessionName.hasError('required')) {
                      <p class="text-error text-sm">Title is required</p>
                    }
                  }
                </div>

                <div>
                  <black-session-picker
                    [liveClassId]="liveClassId ?? null"
                    (sessionSelected)="onSessionSelected($event)"
                  ></black-session-picker>
                  <p class="text-sm text-gray-500 mt-1">
                    Select a past session this recording belongs to, or choose
                    <strong>All Sessions</strong> to make it available to everyone.
                  </p>
                </div>

                <div>
                  <file-pond
                    #myPond
                    [options]="pondOptions"
                    (onaddfile)="pondHandleAddFile($event)"
                  >
                  </file-pond>
                  @if (
                    recordUploadForm.controls.resource.invalid &&
                    (recordUploadForm.controls.resource.dirty ||
                      recordUploadForm.controls.resource.touched)
                  ) {
                    @if (recordUploadForm.controls.resource.hasError('required')) {
                      <p class="text-error text-sm">File is required or file is not ready</p>
                    }
                  }
                </div>

                <button
                  class="daisy-btn daisy-btn-primary daisy-btn-block"
                  type="button"
                  (click)="uploadRecording(close)"
                  [disabled]="!recordUploadForm.valid || !currentUploadContext"
                >
                  Add Recording
                </button>
              </div>
            </form>
          }

          <!-- URL download sub-mode -->
          @if (fileSubMode === 'url-download') {
            <form [formGroup]="urlRecordForm">
              <div class="flex flex-col gap-3">
                <button
                  type="button"
                  class="daisy-btn daisy-btn-ghost daisy-btn-sm self-start"
                  (click)="fileSubMode = null"
                >
                  <i class="fas fa-arrow-left mr-1"></i> Back
                </button>

                <div>
                  <fieldset class="daisy-fieldset">
                    <legend class="daisy-fieldset-legend">Session Title</legend>
                    <input
                      formControlName="sessionName"
                      type="text"
                      required
                      class="daisy-input daisy-input-bordered w-full"
                      placeholder="Enter a title for this recording"
                    />
                  </fieldset>
                  @if (
                    urlRecordForm.controls.sessionName.invalid &&
                    (urlRecordForm.controls.sessionName.dirty ||
                      urlRecordForm.controls.sessionName.touched)
                  ) {
                    <p class="text-error text-sm">Title is required</p>
                  }
                </div>

                <div>
                  <black-session-picker
                    [liveClassId]="liveClassId ?? null"
                    (sessionSelected)="onSessionSelected($event)"
                  ></black-session-picker>
                  <p class="text-sm text-gray-500 mt-1">
                    Select a past session this recording belongs to, or choose
                    <strong>All Sessions</strong> to make it available to everyone.
                  </p>
                </div>

                <div class="flex flex-col gap-1">
                  <label class="text-sm font-medium">Video URL</label>
                  <input
                    type="url"
                    formControlName="url"
                    placeholder="https://example.com/recording.mp4"
                    class="daisy-input daisy-input-bordered w-full"
                  />
                  @if (
                    urlRecordForm.controls.url.invalid &&
                    (urlRecordForm.controls.url.dirty ||
                      urlRecordForm.controls.url.touched)
                  ) {
                    <p class="text-error text-sm">A valid URL starting with http:// or https:// is required.</p>
                  }
                </div>

                @if (urlSubmitError) {
                  <div class="daisy-alert daisy-alert-error text-sm">{{ urlSubmitError }}</div>
                }

                <button
                  class="daisy-btn daisy-btn-primary daisy-btn-block"
                  type="button"
                  (click)="submitUrlRecording(close)"
                  [disabled]="urlRecordForm.invalid || urlSubmitting"
                >
                  @if (urlSubmitting) {
                    <span class="daisy-loading daisy-loading-spinner daisy-loading-sm"></span>
                  } @else {
                    Download &amp; Store Recording
                  }
                </button>
              </div>
            </form>
          }

          <!-- Google Drive sub-mode -->
          @if (fileSubMode === 'google-drive') {
            <form [formGroup]="driveRecordForm">
              <div class="flex flex-col gap-3">
                <button
                  type="button"
                  class="daisy-btn daisy-btn-ghost daisy-btn-sm self-start"
                  (click)="fileSubMode = null; drivePickerError = null"
                >
                  <i class="fas fa-arrow-left mr-1"></i> Back
                </button>

                <div>
                  <fieldset class="daisy-fieldset">
                    <legend class="daisy-fieldset-legend">Session Title</legend>
                    <input
                      formControlName="sessionName"
                      type="text"
                      required
                      class="daisy-input daisy-input-bordered w-full"
                      placeholder="Enter a title for this recording"
                    />
                  </fieldset>
                  @if (
                    driveRecordForm.controls.sessionName.invalid &&
                    (driveRecordForm.controls.sessionName.dirty ||
                      driveRecordForm.controls.sessionName.touched)
                  ) {
                    <p class="text-error text-sm">Title is required</p>
                  }
                </div>

                <div>
                  <black-session-picker
                    [liveClassId]="liveClassId ?? null"
                    (sessionSelected)="onSessionSelected($event)"
                  ></black-session-picker>
                  <p class="text-sm text-gray-500 mt-1">
                    Select a past session this recording belongs to, or choose
                    <strong>All Sessions</strong> to make it available to everyone.
                  </p>
                </div>

                @if (drivePickerError) {
                  <div class="daisy-alert daisy-alert-error text-sm">{{ drivePickerError }}</div>
                }

                <button
                  type="button"
                  class="daisy-btn daisy-btn-primary daisy-btn-block"
                  [disabled]="drivePickerLoading"
                  (click)="selectFromGoogleDrive(close)"
                >
                  @if (drivePickerLoading) {
                    <span class="daisy-loading daisy-loading-spinner daisy-loading-sm"></span>
                    Uploading…
                  } @else {
                    <i class="fab fa-google-drive mr-1"></i>
                    Select from Google Drive
                  }
                </button>
              </div>
            </form>
          }
        }

        <!-- Add a URL tab (external URL, stored as-is) -->
        @if (activeTab === 'external-url') {
          <form [formGroup]="externalUrlForm">
            <div class="flex flex-col gap-3">
              <p class="text-sm text-gray-500">
                The URL will be stored as-is. Clicking play will open the link directly.
              </p>

              <div>
                <fieldset class="daisy-fieldset">
                  <legend class="daisy-fieldset-legend">Session Title</legend>
                  <input
                    formControlName="sessionName"
                    type="text"
                    required
                    class="daisy-input daisy-input-bordered w-full"
                    placeholder="Enter a title for this recording"
                  />
                </fieldset>
                @if (
                  externalUrlForm.controls.sessionName.invalid &&
                  (externalUrlForm.controls.sessionName.dirty ||
                    externalUrlForm.controls.sessionName.touched)
                ) {
                  <p class="text-error text-sm">Title is required</p>
                }
              </div>

              <div>
                <black-session-picker
                  [liveClassId]="liveClassId ?? null"
                  (sessionSelected)="onSessionSelected($event)"
                ></black-session-picker>
                <p class="text-sm text-gray-500 mt-1">
                  Select a past session this recording belongs to, or choose
                  <strong>All Sessions</strong> to make it available to everyone.
                </p>
              </div>

              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium">Video URL</label>
                <input
                  type="url"
                  formControlName="url"
                  placeholder="https://example.com/recording"
                  class="daisy-input daisy-input-bordered w-full"
                />
                @if (
                  externalUrlForm.controls.url.invalid &&
                  (externalUrlForm.controls.url.dirty ||
                    externalUrlForm.controls.url.touched)
                ) {
                  <p class="text-error text-sm">A valid URL starting with http:// or https:// is required.</p>
                }
              </div>

              @if (externalUrlSubmitError) {
                <div class="daisy-alert daisy-alert-error text-sm">{{ externalUrlSubmitError }}</div>
              }

              <button
                class="daisy-btn daisy-btn-primary daisy-btn-block"
                type="button"
                (click)="submitExternalUrlRecording(close)"
                [disabled]="externalUrlForm.invalid || externalUrlSubmitting"
              >
                @if (externalUrlSubmitting) {
                  <span class="daisy-loading daisy-loading-spinner daisy-loading-sm"></span>
                } @else {
                  Add Recording URL
                }
              </button>
            </div>
          </form>
        }
      </div>
    </div>
  </div>
</black-ui-modal>
